const festivals = require('./festivals.json')
const awards = require('./awards.json')
const press = require('./press.json')
const tod = require('./tod.json')
const mainData = require('./main_data.json')

const PROGRAMS = {
  2007: require('./programs/2007.json'),
  2008: require('./programs/2008.json'),
  2009: require('./programs/2009.json'),
  2010: require('./programs/2010.json'),
  2011: require('./programs/2011.json'),
  2012: require('./programs/2012.json'),
  2013: require('./programs/2013.json'),
  2014: require('./programs/2014.json'),
  2015: require('./programs/2015.json'),
  2016: require('./programs/2016.json'),
  2017: require('./programs/2017.json'),
  2018: require('./programs/2018.json'),
  2019: require('./programs/2019.json'),
  2020: require('./programs/2020.json'),
  2022: require('./programs/2022.json'),
  2023: require('./programs/2023.json'),
  2024: require('./programs/2024.json'),
  2025: require('./programs/2025.json'),
  2026: require('./programs/2026.json'),
}

function imageFolderFallback(year) {
  if (year === 2022) return 'images/festivals/2022'
  if (year === 2023) return 'images/2023'
  if (year === 2025) return 'images/2025'
  if (year === 2026) return 'images/2026'
  return 'images'
}

export function getFestivals() {
  return festivals.festivals
}

export function getFestival(year) {
  const id = parseInt(year, 10)
  return getFestivals().find((festival) => festival.id === id) || {
    id,
    name: '',
    logo: 'logo.png',
    imageFolder: imageFolderFallback(id),
    pdf: '',
  }
}

export function getProgram(year) {
  const id = parseInt(year, 10)
  return PROGRAMS[id] || { year: id, dates: [], events: [] }
}

function todayIso() {
  const now = new Date()
  const pad = (n) => String(n).padStart(2, '0')
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`
}

export function isProgramOver(year) {
  const program = getProgram(year)
  const isos = [
    ...(program.dates || []).map((date) => date.iso),
    ...(program.events || []).map((event) => event.tarihIso),
  ].filter(Boolean).sort()
  const last = isos[isos.length - 1]
  return last ? last < todayIso() : parseInt(year, 10) < new Date().getFullYear()
}

function foldVenue(value) {
  return String(value || '')
    .trim()
    .replace(/İ/g, 'i')
    .replace(/I/g, 'i')
    .toLowerCase()
    .replace(/ı/g, 'i')
    .replace(/\s+/g, ' ')
}

export function getTheatre(salon) {
  const target = foldVenue(salon)
  if (!target) return null
  const theatres = mainData.theatres || []
  const exact = theatres.find((theatre) => foldVenue(theatre.name) === target)
  if (exact) return exact
  const contained = theatres.find((theatre) => {
    const name = foldVenue(theatre.name)
    return name.includes(target) || target.includes(name)
  })
  if (contained) return contained
  const head = target.split('/')[0].trim()
  if (!head || head === target) return null
  return theatres.find((theatre) => foldVenue(theatre.name).includes(head)) || null
}

export function getEvent(year, eventId) {
  if (eventId === undefined || eventId === null || eventId === '') return null
  const program = getProgram(year)
  const target = String(eventId)
  const event = (program.events || []).find((item) => String(item.id) === target)
  return event ? { event, program } : null
}

export function flattenEvents(events) {
  const list = []
  for (const event of events || []) {
    if (event.gosteriler && event.gosteriler.length) {
      list.push(...event.gosteriler)
    } else {
      list.push(event)
    }
  }
  return list
}

export function getProgramEvents(year) {
  return flattenEvents(getProgram(year).events)
}

export function posterUrl(yearOrFestival, filename, fallback = '') {
  if (!filename) return fallback
  const folder = typeof yearOrFestival === 'object'
    ? (yearOrFestival.imageFolder || 'images')
    : (getFestival(yearOrFestival).imageFolder || 'images')
  return `${folder}/${filename}`
}

export function getAwards() {
  return awards
}

export function getPress() {
  return press
}

export function getTod() {
  return tod
}
